import { useEffect, useRef } from "react";
import $ from "jquery";

const ConfirmModal = () => {

    const modalTriggerRef = useRef(null);
    const closeBtnRef = useRef(null);

    useEffect(() => {
        const modalEl = document.getElementById("DirConfirmModal");
        if (!modalEl) return;
        const onShown = () => setTimeout(() => closeBtnRef.current?.focus(), 50);
        modalEl.addEventListener("shown.bs.modal", onShown);
        return () => modalEl.removeEventListener("shown.bs.modal", onShown);
    }, []);

    const CloseModal = () => {
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }

        $('#DirConfirmModal').modal('hide');
        modalTriggerRef.current?.focus();
    };
    return (
        <div className="ConfirmModal">
            <div
                className="modal fade"
                id="DirConfirmModal"
                data-backdrop="static"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="DirectoryConfirmationModalTitle"
                aria-describedby="confirmModalDesc"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title" id="DirectoryConfirmationModalTitle"> Confirmed </h3>
                            <button
                                type="button"
                                className="close"
                                aria-label="Close confirmation"
                                onClick={CloseModal}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="bi-success-check" aria-hidden="true">
                              <i className="bi bi-check2-circle"></i>
                            </div>

                            <p
                                className="message-wrapper"
                                id="confirmModalDesc"
                                role="status"
                                aria-live="polite"
                                aria-atomic="true"
                            >
                              Member has been added successfully to your contact list in
                              webmail.
                            </p>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={CloseModal}
                                ref={closeBtnRef}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default ConfirmModal;
